import {
  computed, Directive, ElementRef, HostBinding, input, output, viewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { isShadowSource } from '@hglobal/common';
import { TemplateStageType } from '@pt/models';

export interface BaseStage {
  completed?: boolean;
  status: string;
}

@Directive()
export abstract class StageBaseComponent<T extends BaseStage> {
  openTask = output<any>(); // TODO The type will be fixed in the next task
  stageOrder = input.required<number>();
  stage = input.required<any>(); // TODO The type will be fixed in the next task
  onboardingType = input<TemplateStageType>(null);

  readonly tasksListRef = viewChild<ElementRef>('tasksList');

  #tasksListElement = computed<HTMLElement>(
    () => this.tasksListRef()?.nativeElement,
  );
  isShadowVisible = toSignal(isShadowSource(this.#tasksListElement));

  @HostBinding('class.pt-onboarding-stage_completed') get isCompleted() {
    return this.stage().status === 'completed';
  }

  @HostBinding('class.pt-onboarding-stage_blocked') get isBlocked() {
    return !this.stage().status;
  }

  @HostBinding('class') get onboardingTypeClass() {
    return this.isCompleted ? this.onboardingType() : '';
  }
}
